import { _ as _to_array } from "@swc/helpers/_/_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSignUpPageResultsUpdateEffect } from "@faire/retailer-visitor-shared/components/AppSignUp/AppSignUpPageResultsProvider";
import { LoadingProductTileSkeleton } from "@faire/retailer-visitor-shared/components/LoadingProductTileSkeleton/LoadingProductTileSkeleton";
import { handleShowroomProductBadgeViewed } from "@faire/retailer-visitor-shared/components/Showroom/ShowroomBadgeUtils";
import { TrackedLinkContext } from "@faire/retailer-visitor-shared/components/TrackedLink/index";
import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { getAltTag } from "@faire/retailer-visitor-shared/features/Marketplace/utils";
import { MarketplaceProduct } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/MarketplaceProduct";
import { SaveToBoardProvider } from "@faire/retailer-visitor-shared/features/RetailerBoards/Context";
import { ProductTileClickImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { generateProductLinkPropsForLoggedOutRetailer } from "@faire/retailer-visitor-shared/lib/generateProductLinkPropsForLoggedOutRetailer";
import { brandPage } from "@faire/retailer-visitor-shared/paths/index";
import { useCategoryStore } from "@faire/retailer-visitor-shared/stores/domain/CategoryStore";
import { LoggedOutCategoryPageItemList } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/components/LoggedOutCategoryPageFilterAndResults/__internal__/LoggedOutCategoryPageItemList";
import { useLoggedOutCategoryPageCurrentCategory } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentCategory";
import { useLoggedOutCategoryPageCatNavResponse } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageCatNav/useLoggedOutCategoryPageCatNavResponse";
import { useLoggedOutCategoryPageMetaTags } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/DataFetching/useLoggedOutCategoryPageMetaTags";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { trackCategoriesLoggedOutProductBatchView } from "@faire/web-api--source/events/categories/view/loggedOutProductBatch";
import { trackSeoCategoryProductListProductLinkRefsClick } from "@faire/web-api--source/events/seo/click/categoryProductListProductLinkRefs";
import { trackSignupModalOpenCatnavProductTileClick } from "@faire/web-api--source/events/signup/click/modalOpenCatnavProductTile";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import React, { useCallback, useRef } from "react";
import { useLocation } from "react-router-dom";
export var LoggedOutCategoryPageProductList = function() {
    var location = useLocation();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var seoCategoryText = useLoggedOutCategoryPageMetaTags().seoCategoryText;
    var _seoCategoryText_h1;
    var title = (_seoCategoryText_h1 = seoCategoryText === null || seoCategoryText === void 0 ? void 0 : seoCategoryText.h1) !== null && _seoCategoryText_h1 !== void 0 ? _seoCategoryText_h1 : "";
    var containerName = "logged_out_category_product_grid";
    var badgeViewedProductTokens = useRef(new Set());
    var shouldShowVerticalTile = useCategoryStore().shouldShowVerticalTile;
    var categoryModel = useLoggedOutCategoryPageCurrentCategory();
    var _useLoggedOutCategoryPageCatNavResponse = useLoggedOutCategoryPageCatNavResponse(), _useLoggedOutCategoryPageCatNavResponse_data = _useLoggedOutCategoryPageCatNavResponse.data, requestId = _useLoggedOutCategoryPageCatNavResponse_data.requestId, brandPageQueryParams = _useLoggedOutCategoryPageCatNavResponse_data.brandPageQueryParams, productFirstSearchResults = _useLoggedOutCategoryPageCatNavResponse_data.productFirstSearchResults;
    useAppSignUpPageResultsUpdateEffect({
        productTiles: productFirstSearchResults
    });
    var onProductBatchVisible = useCallback(function(items) {
        if (requestId) {
            trackCategoriesLoggedOutProductBatchView(requestId, items.map(function(i) {
                var _i_product;
                return i === null || i === void 0 ? void 0 : (_i_product = i.product) === null || _i_product === void 0 ? void 0 : _i_product.token;
            }).filter(isNotUndefined).join(" "));
        }
    }, [
        requestId
    ]);
    var onClickProduct = useCallback(function(product) {
        trackSignupModalOpenCatnavProductTileClick();
        if (product.token) {
            var _categoryModel_urlIdStrings;
            var _ref = _to_array((_categoryModel_urlIdStrings = categoryModel.urlIdStrings) !== null && _categoryModel_urlIdStrings !== void 0 ? _categoryModel_urlIdStrings : []), tmp = _ref[0], c1UrlId = tmp === void 0 ? "" : tmp, subcategoryUrlIds = _ref.slice(1);
            trackSeoCategoryProductListProductLinkRefsClick(product.token, // c1 UrlId
            c1UrlId, // remaining url IDs
            subcategoryUrlIds.join("|"));
        }
    }, [
        categoryModel
    ]);
    var onProductBadgeVisible = function(productToken, topLeftTileBadge) {
        if (!productToken || badgeViewedProductTokens.current.has(productToken)) {
            return;
        }
        badgeViewedProductTokens.current.add(productToken);
        handleShowroomProductBadgeViewed(productToken, requestId, topLeftTileBadge);
    };
    var renderItem = function(tileData) {
        var _tileData_product;
        if (!tileData) {
            return /*#__PURE__*/ _jsx(LoadingProductTileSkeleton, {});
        }
        return /*#__PURE__*/ _jsx(MarketplaceProduct, {
            altTag: getAltTag({
                pageType: PAGE_TYPE.CATEGORY,
                productName: tileData === null || tileData === void 0 ? void 0 : (_tileData_product = tileData.product) === null || _tileData_product === void 0 ? void 0 : _tileData_product.name,
                title: title
            }, strictLocalize),
            productTile: tileData,
            brand: tileData === null || tileData === void 0 ? void 0 : tileData.brand,
            generateProductLinkProps: function(productToken) {
                var _tileData_brand;
                return generateProductLinkPropsForLoggedOutRetailer({
                    productToken: productToken,
                    brandToken: tileData === null || tileData === void 0 ? void 0 : (_tileData_brand = tileData.brand) === null || _tileData_brand === void 0 ? void 0 : _tileData_brand.token,
                    location: location
                });
            },
            generateBrandUrl: function(brandToken) {
                return brandPage(brandToken, brandPageQueryParams);
            },
            onClick: onClickProduct,
            showVerticalImagery: shouldShowVerticalTile(categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.mostSpecificPathIdentifier),
            onProductVisible: onProductBadgeVisible,
            recordAdImpression: true
        });
    };
    var _categoryModel_mostSpecificPathIdentifier;
    return /*#__PURE__*/ _jsx(ProductTileClickImpressionProvider, {
        context: "".concat(ProductTileContainer.CATEGORY_PRODUCT_RESULTS_GRID, "|").concat(categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.mostSpecificPathIdentifier),
        productTileContainer: ProductTileContainer.CATEGORY_PRODUCT_RESULTS_GRID,
        containerName: containerName,
        requestId: requestId,
        isNewProductsCategory: categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.isNewProducts,
        screenContext: ProductTileScreen.CATEGORY_PRODUCT_RESULTS,
        containerContext: ProductTileScreenContainer.CATEGORY_PRODUCT_RESULTS_PRODUCTS,
        contextToken: (_categoryModel_mostSpecificPathIdentifier = categoryModel === null || categoryModel === void 0 ? void 0 : categoryModel.mostSpecificPathIdentifier) !== null && _categoryModel_mostSpecificPathIdentifier !== void 0 ? _categoryModel_mostSpecificPathIdentifier : "",
        children: /*#__PURE__*/ _jsx(TrackedLinkContext.Provider, {
            value: {
                type: IClickInfo.Type.PRODUCT,
                requestId: requestId,
                containerName: containerName
            },
            children: /*#__PURE__*/ _jsx(SaveToBoardProvider, {
                value: {
                    trackOrigin: "logged-out-category-page"
                },
                children: /*#__PURE__*/ _jsx(LoggedOutCategoryPageItemList, {
                    items: productFirstSearchResults !== null && productFirstSearchResults !== void 0 ? productFirstSearchResults : [],
                    renderItem: renderItem,
                    onBatchVisible: onProductBatchVisible,
                    hashKey: requestId
                })
            })
        })
    });
};
